import React from 'react';
import { FeatureContainer, FeatureButton } from './FeatureElements';

const Feature = () => {
  return (
    <FeatureContainer>
      <h1></h1>
      <p>                                         

Servicio de excavación, cloacas, nivelación y mucho mas!</p>
      <FeatureButton>GARANTIA DE CONFIANZA</FeatureButton>
    </FeatureContainer>
  );
};

export default Feature;
